import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, HostListener, NgModule } from '@angular/core';
import * as i3 from '@progress/kendo-angular-dateinputs';
import { DateRangeService, DateInputsModule } from '@progress/kendo-angular-dateinputs';
import * as i1 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';
import { EIPMessageBoxComponent } from 'eipmessage-box';
import * as i2 from '@angular/material/dialog';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { IntlModule } from '@progress/kendo-angular-intl';
import { LabelModule } from '@progress/kendo-angular-label';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { PopupModule } from '@progress/kendo-angular-popup';
import { InputsModule } from '@progress/kendo-angular-inputs';

class EIPDateRangePickerService {
    constructor() { }
}
EIPDateRangePickerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EIPDateRangePickerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class EIPDateRangePickerComponent {
    constructor(datePipe, dialog, renderer) {
        this.datePipe = datePipe;
        this.dialog = dialog;
        this.renderer = renderer;
        this.setId = 'dateRange_Kendo';
        this.WaterMark = '';
        this.MinYear = 1900;
        this.IsDateDisabled = false;
        this.IsDateReadonly = false;
        this.ShowClearIcon = false;
        this.dateRangeReadonly = '';
        this.AllowedSplChars = '-~/';
        this.selected = '';
        this.displayingDate = '';
        this.clearValue = 'N';
        this.IsSelectionRequired = false;
        this.selectedStartDate = new EventEmitter();
        this.selectedEndDate = new EventEmitter();
        this.SelectedDateEmitter = new EventEmitter();
        this.calenderBlurEvent = new EventEmitter();
        this.toggleText = 'Show';
        this.show = false;
        this.shouldShow = false;
        this.showError = false;
        this.count = 1;
        this.userEntered = '';
        this.formatMessage = 'Enter the correct date format';
        this.incompleteMessage = 'Enter both start and end dates of correct length';
        this.inputLength = 1;
        this.dateMismatch = 'Start date should be less than the end date';
        this.listOfDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        this.months = [
            'jan',
            'feb',
            'mar',
            'apr',
            'may',
            'jun',
            'jul',
            'aug',
            'sep',
            'oct',
            'nov',
            'dec'
        ];
        this.startEntered = '';
        this.endEntered = '';
        this.range = {
            start: new Date(),
            end: new Date()
        };
        this.rangeLength = 7;
        this.isInitialize = false;
        this.monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        setTimeout(() => {
            if (!this.WaterMark) {
                this.WaterMark = 'DD-MMM-YYYY - DD-MMM-YYYY';
            }
        }, 1000);
        this.shownMessage = this.formatMessage;
        const currentDate = new Date();
        this.changedDate = currentDate.getDate();
        this.changedMonth = this.months[currentDate.getMonth()];
        this.changedYear = currentDate.getFullYear();
        this.startEntered =
            this.changedDate +
                '-' +
                this.changedMonth.toUpperCase() +
                '-' +
                this.changedYear;
        this.changedDate = currentDate.getDate();
        this.changedMonth = this.months[currentDate.getMonth()];
        this.changedYear = currentDate.getFullYear();
        this.endEntered =
            this.changedDate +
                '-' +
                this.changedMonth.toUpperCase() +
                '-' +
                this.changedYear;
        this.shouldShow = true;
    }
    popupOpenClick(popup, eventClick, setId) {
        this.closeExistingPopups();
        popup.toggle();
        this.documentClickSubscription = this.renderer.listen('document', 'click', (event) => {
            if (event.target && event.target.id !== `icon-right${setId}` && this.popup.show === true &&
                !this.popup.calendar.element.nativeElement.contains(event.target)) {
                if (this.monthArr.indexOf(event.target.textContent) === -1) {
                    this.popup.toggle();
                    this.documentClickSubscription();
                }
            }
        });
    }
    // source = fromEvent(document, 'click');
    // docClickSubcription: Subscription;
    ngOnChanges(event) {
        if (!event.Min && !event.Max) {
            if (this.isInitialize) {
                if (this.clearValue === 'Y') {
                    this.displayingDate = null;
                    this.range.start = null;
                    // this.range.end = null;
                }
                else {
                    setTimeout(() => {
                        if (!this.WaterMark) {
                            this.WaterMark = 'DD-MMM-YYYY - DD-MMM-YYYY';
                        }
                    }, 1000);
                    this.endDate = new Date();
                    let displayingDate = '';
                    this.valueStart = this.valueStart == null ? new Date() : this.valueStart;
                    this.valueEnd = this.valueEnd == null ? new Date() : this.valueEnd;
                    this.startDate = new Date(new Date().setDate(this.endDate.getDate() - 30));
                    this.valueStart = this.datePipe.transform(this.valueStart, 'dd,MMM,yyyy');
                    this.valueEnd = this.datePipe.transform(this.valueEnd, 'dd,MMM,yyyy');
                    displayingDate = this.valueStart + ' - ' + this.valueEnd;
                    this.displayingDate = displayingDate.replace(/,/g, '-');
                    this.range.start = new Date(this.valueStart);
                    this.range.end = new Date(this.valueEnd);
                }
            }
        }
    }
    ngOnInit() {
        this.isInitialize = true;
        if (this.IsDateReadonly) {
            this.dateRangeReadonly = 'readonly';
        }
        if (this.clearValue === 'Y') {
            this.displayingDate = null;
            this.range.start = null;
            // this.range.end = null;
        }
        else {
            setTimeout(() => {
                if (!this.WaterMark) {
                    this.WaterMark = 'DD-MMM-YYYY - DD-MMM-YYYY';
                }
            }, 1000);
            if (this.valueStart && this.valueEnd) {
                this.endDate = new Date();
                let displayingDate = '';
                this.valueStart = this.valueStart == null ? new Date() : this.valueStart;
                this.valueEnd = this.valueEnd == null ? new Date() : this.valueEnd;
                this.startDate = new Date(new Date().setDate(this.endDate.getDate() - 30));
                this.valueStart = this.datePipe.transform(this.valueStart, 'dd,MMM,yyyy');
                this.valueEnd = this.datePipe.transform(this.valueEnd, 'dd,MMM,yyyy');
                displayingDate = this.valueStart + ' - ' + this.valueEnd;
                this.displayingDate = displayingDate.replace(/,/g, '-');
                this.range.start = new Date(this.valueStart);
                this.range.end = new Date(this.valueEnd);
                // this.range.start = new Date(this.valueStart.replace(/-/g, ','));
                // this.range.end = new Date(this.valueEnd.replace(/-/g, ','));
            }
        }
    }
    ngOnDestroy() {
        const temp = document.getElementById(this.setId);
        if (temp) {
            temp.remove();
        }
        if (this.documentClickSubscription) {
            this.documentClickSubscription();
        }
        if (this.errorMessageBoxSubscription) {
            this.errorMessageBoxSubscription.unsubscribe();
        }
    }
    closeExistingPopups() {
        const existingPopups = document.getElementsByClassName('calenderDateRange');
        let parentNode;
        if (existingPopups.length > 0) {
            parentNode = existingPopups[0].parentNode.parentNode;
            console.log(parentNode);
            parentNode.remove();
        }
    }
    maxMinValidation() {
        let minValValue;
        let minOriginalValue;
        minOriginalValue = this.Min;
        minOriginalValue = this.datePipe.transform(minOriginalValue, 'dd,MMM,yyyy');
        minValValue = new Date();
        minValValue = this.datePipe.transform(minValValue, 'dd,MMM,yyyy');
        if (this.Max) {
            this.Max = new Date(this.Max.getFullYear(), this.Max.getMonth() - 1, this.Max.getDate(), 10, 30);
        }
        if (this.Min) {
            if (minOriginalValue >= minValValue) {
                this.Min = new Date(this.Min.getFullYear(), this.Min.getMonth(), this.Min.getDate(), 10, 30);
            }
            else {
                this.Min = new Date(this.Min.getFullYear(), this.Min.getMonth() - 1, this.Min.getDate(), 10, 30);
            }
        }
        if (this.Value) {
            this.Value = new Date(this.Value.getFullYear(), this.Value.getMonth() - 1, this.Value.getDate(), 10, 30);
        }
    }
    handleSelectionRange(range) {
        let valueStart;
        let valueEnd;
        let displayingDate = '';
        valueStart = this.datePipe.transform(range.start, 'dd,MMM,yyyy');
        valueEnd = this.datePipe.transform(range.end, 'dd,MMM,yyyy');
        if (+valueStart.split(',')[2] < this.MinYear) {
            valueStart = this.datePipe.transform(new Date(), 'dd,MMM,yyyy');
        }
        if (+valueEnd.split(',')[2] < this.MinYear) {
            valueEnd = this.datePipe.transform(new Date(), 'dd,MMM,yyyy');
        }
        displayingDate = valueStart + ' - ' + valueEnd;
        this.displayingDate = displayingDate.replace(/,/g, '-');
        this.range = { start: range.start, end: range.end };
        if (valueStart) {
            const startDateEmit = {
                startDate: valueStart.replace(/,/g, '-')
            };
            this.selectedStartDate.emit(valueStart.replace(/,/g, '-'));
            this.SelectedDateEmitter.emit(startDateEmit);
        }
        if (valueEnd) {
            const endDateEmit = {
                endDate: valueEnd.replace(/,/g, '-')
            };
            this.selectedEndDate.emit(valueEnd.replace(/,/g, '-'));
            this.SelectedDateEmitter.emit(endDateEmit);
        }
        event.preventDefault();
    }
    toggle(show) {
        if (this.IsDateDisabled) {
            show = false;
            return;
        }
        this.show = show !== undefined ? show : !this.show;
        this.toggleText = this.show ? 'Hide' : 'Show';
        if (this.show) {
            this.popup.toggle();
        }
    }
    keydown(event) {
        if (event.keyCode === 27) {
            this.toggle(false);
            this.popup.toggle();
        }
        if (event.keyCode === 9) {
            this.toggle(false);
            this.popup.toggle();
        }
    }
    // @HostListener('document:click', ['$event'])
    // public documentClick(event) {
    //   if (event.target) {
    //     if (event.target.id !== 'icon-right' && (this.popup.show &&
    //       !this.popup.calendar.element.nativeElement.contains(event.target))) {
    //       if (event.target.textContent !== 'Jan'
    //         && event.target.textContent !== 'Feb'
    //         && event.target.textContent !== 'Mar'
    //         && event.target.textContent !== 'Apr'
    //         && event.target.textContent !== 'May'
    //         && event.target.textContent !== 'Jun'
    //         && event.target.textContent !== 'Jul'
    //         && event.target.textContent !== 'Aug'
    //         && event.target.textContent !== 'Sep'
    //         && event.target.textContent !== 'Oct'
    //         && event.target.textContent !== 'Nov'
    //         && event.target.textContent !== 'Dec') {
    //         this.popup.toggle();
    //       }
    //     }
    //   }
    // }
    dateValidate(event) {
        if (event.length > 0) {
            this.inputLength = 1;
            this.showError = false;
            const dt = this.displayingDate.split(' - ');
            if (dt.length > 1) {
                dt[0] = dt[0].replace(/-/g, ',');
                dt[1] = dt[1].replace(/-/g, ',');
                dt[0] = dt[0].replace(/[^a-zA-Z0-9_-]/g, ',');
                dt[1] = dt[1].replace(/[^a-zA-Z0-9_-]/g, ',');
                if (dt !== undefined && dt != null) {
                    if (JSON.stringify(new Date(dt[0])) == 'null') {
                        dt[0] = this.datePipe.transform(new Date(), 'dd,MMM,yyyy');
                    }
                    if (JSON.stringify(new Date(dt[1])) == 'null') {
                        dt[1] = this.datePipe.transform(new Date(), 'dd,MMM,yyyy');
                    }
                    if (new Date(dt[0]) > new Date(dt[1])) {
                        this.displayingDate = dt[1] + ' - ' + dt[1];
                        this.range.start = new Date(dt[1]);
                        this.range.end = new Date(dt[1]);
                        this.showErrorMessageBox();
                        this.range.start = new Date();
                        this.range.end = new Date();
                        const dateRange = {
                            start: this.range.start,
                            end: this.range.end
                        };
                        this.handleSelectionRange(dateRange);
                        return;
                    }
                    else {
                        this.range.start = new Date(dt[0]);
                        this.range.end = new Date(dt[1]);
                    }
                }
                if (this.Min) {
                    if (this.range.start < this.Min) {
                        this.range.start = this.Min;
                        // this.showMinMaxErrorMessageBox('From date should be within a minimum date allowed');
                        // return;
                    }
                }
                if (this.Max) {
                    if (this.range.end > this.Max) {
                        this.range.end = this.Max;
                        // this.showMinMaxErrorMessageBox('To date should be within a maximum date allowed');
                        // return;
                    }
                }
                const dateRange = {
                    start: this.range.start,
                    end: this.range.end
                };
                this.handleSelectionRange(dateRange);
            }
            else {
                this.range.start = new Date();
                this.range.end = new Date();
                if (this.Min) {
                    if (this.range.start < this.Min) {
                        this.range.start = this.Min;
                        if (this.Max) {
                            this.range.end = this.Max;
                        }
                    }
                }
                if (this.Max) {
                    if (this.range.end > this.Max) {
                        this.range.end = this.Max;
                    }
                }
                const dateRange = {
                    start: this.range.start,
                    end: this.range.end
                };
                this.handleSelectionRange(dateRange);
            }
        }
        else {
            this.inputLength = 0;
            this.selectedStartDate.emit(null);
            this.selectedEndDate.emit(null);
        }
    }
    showErrorMessageBox() {
        const _message = 'Start date should be less than the end date';
        const _title = 'Error';
        const _messageType = 'Error';
        const _dialog = this.dialog;
        if (_dialog.open) {
            const dialogRef = _dialog.open(EIPMessageBoxComponent, {
                panelClass: 'eip-messagebox-popup',
                disableClose: true,
                data: { _title, _message, _messageType }
            });
            this.errorMessageBoxSubscription = dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    //   console.log(result)
                    switch (result) {
                        case 'ok': {
                            //  this.OKClickChange(result);
                            // Write logic for 'ok' button click
                            break;
                        }
                        case 'cancel': {
                            // this.CancelClickChange(result)
                            // write logic for 'cancel' button click
                            break;
                        }
                    }
                }
            });
        }
    }
    showMinMaxErrorMessageBox(message) {
        const _message = message;
        const _title = 'Error';
        const _messageType = 'Error';
        const _dialog = this.dialog;
        if (_dialog.open) {
            const dialogRef = _dialog.open(EIPMessageBoxComponent, {
                panelClass: 'eip-messagebox-popup',
                disableClose: true,
                data: { _title, _message, _messageType }
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    //   console.log(result)
                    switch (result) {
                        case 'ok': {
                            //  this.OKClickChange(result);
                            // Write logic for 'ok' button click
                            break;
                        }
                        case 'cancel': {
                            // this.CancelClickChange(result)
                            // write logic for 'cancel' button click
                            break;
                        }
                    }
                }
            });
        }
    }
    completeCheck() {
        this.showError = false;
        if (this.inputLength !== 0) {
            if (this.startEntered.trim().length === 0 || this.endEntered.trim().length === 0) {
                this.showError = false;
            }
            else if (this.startEntered.trim().length !== 11 || this.endEntered.trim().length !== 11) {
                this.shownMessage = this.incompleteMessage;
                this.showError = true;
            }
            else if (this.startEntered.trim().charAt(2) !== '-' ||
                this.startEntered.trim().charAt(6) !== '-' ||
                (this.endEntered.trim().charAt(2) !== '-' || this.endEntered.trim().charAt(6) !== '-')) {
                this.shownMessage = this.formatMessage;
                this.showError = true;
            }
            else if (this.startEntered.trim().length === 11 &&
                this.endEntered.trim().length === 11) {
                const startSplit = this.startEntered.trim().split('-');
                const endSplit = this.endEntered.trim().split('-');
                if (this.checkConditions(startSplit[0], startSplit[1], startSplit[2]) &&
                    this.checkConditions(endSplit[0], endSplit[1], endSplit[2])) {
                    // this.showError = false;
                    // this.shouldShow = true;
                    this.focused = new Date(parseInt(startSplit[2], 10), this.months.indexOf(startSplit[1].toLowerCase()), parseInt(startSplit[0], 10));
                    this.range.start = this.focused;
                    this.range.end = new Date(parseInt(endSplit[2], 10), this.months.indexOf(endSplit[1].toLowerCase()), parseInt(endSplit[0], 10));
                    if (this.range.start > this.range.end) {
                        this.shownMessage = this.dateMismatch;
                        this.showError = true;
                    }
                    else {
                        this.showError = false;
                        this.shouldShow = true;
                    }
                }
                else {
                    this.shownMessage = this.formatMessage;
                    this.showError = true;
                }
            }
            else {
                this.shownMessage = this.formatMessage;
                this.showError = true;
            }
        }
    }
    collapse() {
        this.shouldShow = false;
    }
    checkConditions(date, month, year) {
        if (!this.noChars(date) || !this.noChars(year)) {
            return false;
        }
        const mm = this.months.indexOf(month.toLowerCase());
        const dd = parseInt(date, 10);
        const yy = parseInt(year, 10);
        if (mm === -1) {
            return false;
        }
        if (yy < 1900 || yy > 2099) {
            return false;
        }
        if (dd < 0 || dd > 31) {
            return false;
        }
        if (mm === 0 || mm > 1) {
            if (dd > this.listOfDays[mm]) {
                return false;
            }
        }
        if (mm === 1) {
            let isLeap = false;
            if ((!(yy % 4) && yy % 100) || !(yy % 400)) {
                isLeap = true;
            }
            if (isLeap === false && dd >= 29) {
                return false;
            }
            if (isLeap === true && dd > 29) {
                return false;
            }
        }
        return true;
    }
    noChars(date) {
        for (let i = 0; i < date.length; i++) {
            if (date.charCodeAt(i) < 47 || date.charCodeAt(i) > 57) {
                return false;
            }
        }
        return true;
    }
    insertSlash($event) {
        this.shouldShow = false;
        this.show = false;
        const strsplit = this.AllowedSplChars.split('~');
        let splchars = '[^A-Za-z0-9';
        let i = 0;
        if (strsplit) {
            for (i = 0; i < 3; i++) {
                splchars += '\\' + strsplit[i];
            }
        }
        splchars = splchars + ']';
        const pattern = new RegExp(splchars);
        const modifiedDate = this.displayingDate.replace(pattern, '');
        this.startEntered = modifiedDate.substr(0, 11);
        this.endEntered = modifiedDate.substr(12, 23);
        this.completeCheck();
    }
    onInputChange() {
        const strsplit = this.AllowedSplChars.split('~');
        let splchars = '[^A-Za-z0-9';
        let i = 0;
        if (strsplit) {
            for (i = 0; i < 3; i++) {
                splchars += '\\' + strsplit[i];
            }
        }
        splchars = splchars + ']';
        const pattern = new RegExp(splchars);
        this.Value = this.Value = new Date();
        // this.Value.replace(pattern, '');
    }
    calenderBlurEventEmit(event) {
        this.calenderBlurEvent.emit(event);
    }
    clear() {
        this.displayingDate = null;
        this.inputLength = 0;
        this.selectedStartDate.emit(null);
        this.selectedEndDate.emit(null);
    }
}
EIPDateRangePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerComponent, deps: [{ token: i1.DatePipe }, { token: i2.MatDialog }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
EIPDateRangePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: EIPDateRangePickerComponent, selector: "EIPDateRangePicker", inputs: { Value: "Value", startDate: "startDate", endDate: "endDate", valueStart: "valueStart", valueEnd: "valueEnd", Min: "Min", Max: "Max", setId: "setId", WaterMark: "WaterMark", MinYear: "MinYear", IsDateDisabled: "IsDateDisabled", IsDateReadonly: "IsDateReadonly", ShowClearIcon: "ShowClearIcon", clearValue: "clearValue", IsSelectionRequired: "IsSelectionRequired" }, outputs: { selectedStartDate: "selectedStartDate", selectedEndDate: "selectedEndDate", SelectedDateEmitter: "SelectedDateEmitter", calenderBlurEvent: "calenderBlurEvent" }, host: { listeners: { "keydown": "keydown($event)" } }, providers: [DatePipe, DateRangeService], viewQueries: [{ propertyName: "anchor", first: true, predicate: ["anchor"], descendants: true }, { propertyName: "popup", first: true, predicate: ["popup"], descendants: true }, { propertyName: "dateRangeInput", first: true, predicate: ["dateRangeInput"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div>\r\n  <div class=\"date-range-picker\">\r\n    <!-- <kendo-textbox-container [ngClass]=\"IsDateDisabled ? 'daterangepickerdisable' : ''\"\r\n    class=\"daterangepicker\"\r\n      [floatingLabel]=\"WaterMark\"> -->\r\n    <div class=\"date-range\" #anchor>\r\n      <span class=\"k-textbox k-space-right\" style=\"width: 100%;\">\r\n\r\n        <input [readonly]=\"dateRangeReadonly\" [disabled]=\"IsDateDisabled\" type=\"text\" id=\"{{'icon-right' + setId}}\"\r\n          class=\"CCDPClass k-input\" [placeholder]=\"WaterMark\" [(ngModel)]=\"displayingDate\" (keyup)=\"insertSlash($event)\"\r\n          (click)=\"popupOpenClick(popup, $event, setId)\" (blur)=\"dateValidate(displayingDate)\" autocomplete=\"off\" />\r\n\r\n        <a id=\"{{'icon-right' + setId}}\" class=\"pr-2 fa fa-close\" *ngIf=\"displayingDate && ShowClearIcon\"\r\n          (click)=\"clear()\"></a>\r\n        <a id=\"{{'icon-right' + setId}}\" *ngIf=\"!IsDateDisabled\" class=\"fa fa-calendar\"\r\n          (click)=\"popupOpenClick(popup, $event, setId)\"></a>\r\n      </span>\r\n\r\n    </div>\r\n    <!-- </kendo-textbox-container> -->\r\n\r\n  </div>\r\n\r\n  <kendo-daterange-popup class=\"kendo_DRP\" [anchor]=\"{ nativeElement: anchor }\" #popup>\r\n    <ng-template kendoDateRangePopupTemplate>\r\n      <kendo-multiviewcalendar #eipCalender [min]=\"Min\" [max]=\"Max\" class=\"CCDPClass calenderDateRange\" [id]=\"setId\"\r\n        [selectionRange]=\"range\" (blur)=\"calenderBlurEventEmit($event)\"\r\n        (selectionRangeChange)=\"handleSelectionRange($event)\" kendoDateRangeSelection>\r\n      </kendo-multiviewcalendar>\r\n    </ng-template>\r\n  </kendo-daterange-popup>\r\n  <p *ngIf=\"showError\">{{shownMessage}}</p>\r\n</div>", styles: [".daterangepicker,.CCDPClass{width:100%!important}.daterangepickerdisable{opacity:.2}@media (max-width: 575px){::ng-deep .CCDPClass.k-calendar.k-calendar-range.k-calendar-infinite:not(.k-calendar-minimal)>.k-calendar-view{width:68%!important;overflow-x:auto}::ng-deep .CCDPClass.k-calendar .k-calendar-header{width:100%!important;display:inline-table}::ng-deep .CCDPClass.k-calendar .k-calendar-header .k-today{margin-left:13em!important}}\n"], components: [{ type: i3.DateRangePopupComponent, selector: "kendo-daterange-popup", inputs: ["animate", "collision", "anchor", "anchorAlign", "appendTo", "popupAlign", "margin"], outputs: ["open", "close", "blur", "focus", "cancel"], exportAs: ["kendo-daterange-popup"] }, { type: i3.MultiViewCalendarComponent, selector: "kendo-multiviewcalendar", inputs: ["id", "rangeValidation", "disabledDatesRangeValidation", "disabled", "tabindex", "activeView", "bottomView", "topView", "weekNumber", "views", "focusedDate", "min", "max", "value", "tabIndex", "disabledDates", "selectionRange", "cellTemplate", "monthCellTemplate", "yearCellTemplate", "decadeCellTemplate", "centuryCellTemplate", "weekNumberTemplate", "headerTitleTemplate", "activeRangeEnd"], outputs: ["activeViewChange", "cellEnter", "cellLeave", "valueChange"], exportAs: ["kendo-multiviewcalendar"] }], directives: [{ type: i4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.DateRangePopupTemplateDirective, selector: "[kendoDateRangePopupTemplate]" }, { type: i3.DateRangeSelectionDirective, selector: "[kendoDateRangeSelection]", inputs: ["autoCorrectOn", "selectionRange", "activeRangeEnd"], outputs: ["activeRangeEndChange", "selectionRangeChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'EIPDateRangePicker', providers: [DatePipe, DateRangeService], template: "<div>\r\n  <div class=\"date-range-picker\">\r\n    <!-- <kendo-textbox-container [ngClass]=\"IsDateDisabled ? 'daterangepickerdisable' : ''\"\r\n    class=\"daterangepicker\"\r\n      [floatingLabel]=\"WaterMark\"> -->\r\n    <div class=\"date-range\" #anchor>\r\n      <span class=\"k-textbox k-space-right\" style=\"width: 100%;\">\r\n\r\n        <input [readonly]=\"dateRangeReadonly\" [disabled]=\"IsDateDisabled\" type=\"text\" id=\"{{'icon-right' + setId}}\"\r\n          class=\"CCDPClass k-input\" [placeholder]=\"WaterMark\" [(ngModel)]=\"displayingDate\" (keyup)=\"insertSlash($event)\"\r\n          (click)=\"popupOpenClick(popup, $event, setId)\" (blur)=\"dateValidate(displayingDate)\" autocomplete=\"off\" />\r\n\r\n        <a id=\"{{'icon-right' + setId}}\" class=\"pr-2 fa fa-close\" *ngIf=\"displayingDate && ShowClearIcon\"\r\n          (click)=\"clear()\"></a>\r\n        <a id=\"{{'icon-right' + setId}}\" *ngIf=\"!IsDateDisabled\" class=\"fa fa-calendar\"\r\n          (click)=\"popupOpenClick(popup, $event, setId)\"></a>\r\n      </span>\r\n\r\n    </div>\r\n    <!-- </kendo-textbox-container> -->\r\n\r\n  </div>\r\n\r\n  <kendo-daterange-popup class=\"kendo_DRP\" [anchor]=\"{ nativeElement: anchor }\" #popup>\r\n    <ng-template kendoDateRangePopupTemplate>\r\n      <kendo-multiviewcalendar #eipCalender [min]=\"Min\" [max]=\"Max\" class=\"CCDPClass calenderDateRange\" [id]=\"setId\"\r\n        [selectionRange]=\"range\" (blur)=\"calenderBlurEventEmit($event)\"\r\n        (selectionRangeChange)=\"handleSelectionRange($event)\" kendoDateRangeSelection>\r\n      </kendo-multiviewcalendar>\r\n    </ng-template>\r\n  </kendo-daterange-popup>\r\n  <p *ngIf=\"showError\">{{shownMessage}}</p>\r\n</div>", styles: [".daterangepicker,.CCDPClass{width:100%!important}.daterangepickerdisable{opacity:.2}@media (max-width: 575px){::ng-deep .CCDPClass.k-calendar.k-calendar-range.k-calendar-infinite:not(.k-calendar-minimal)>.k-calendar-view{width:68%!important;overflow-x:auto}::ng-deep .CCDPClass.k-calendar .k-calendar-header{width:100%!important;display:inline-table}::ng-deep .CCDPClass.k-calendar .k-calendar-header .k-today{margin-left:13em!important}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.DatePipe }, { type: i2.MatDialog }, { type: i0.Renderer2 }]; }, propDecorators: { Value: [{
                type: Input
            }], startDate: [{
                type: Input
            }], endDate: [{
                type: Input
            }], valueStart: [{
                type: Input
            }], valueEnd: [{
                type: Input
            }], Min: [{
                type: Input
            }], Max: [{
                type: Input
            }], setId: [{
                type: Input
            }], WaterMark: [{
                type: Input
            }], MinYear: [{
                type: Input
            }], IsDateDisabled: [{
                type: Input
            }], IsDateReadonly: [{
                type: Input
            }], ShowClearIcon: [{
                type: Input
            }], clearValue: [{
                type: Input
            }], IsSelectionRequired: [{
                type: Input
            }], selectedStartDate: [{
                type: Output
            }], selectedEndDate: [{
                type: Output
            }], SelectedDateEmitter: [{
                type: Output
            }], calenderBlurEvent: [{
                type: Output
            }], anchor: [{
                type: ViewChild,
                args: ['anchor', { static: false }]
            }], popup: [{
                type: ViewChild,
                args: ['popup', { static: false }]
            }], dateRangeInput: [{
                type: ViewChild,
                args: ['dateRangeInput', { static: false }]
            }], keydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class EIPDateRangePickerModule {
}
EIPDateRangePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPDateRangePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerModule, declarations: [EIPDateRangePickerComponent], imports: [CommonModule, IntlModule,
        DateInputsModule, LabelModule, MatFormFieldModule, InputsModule,
        MatSelectModule, MatOptionModule, FormsModule, PopupModule // , BrowserAnimationsModule
    ], exports: [EIPDateRangePickerComponent] });
EIPDateRangePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerModule, providers: [DateRangeService], imports: [[CommonModule, IntlModule,
            DateInputsModule, LabelModule, MatFormFieldModule, InputsModule,
            MatSelectModule, MatOptionModule, FormsModule, PopupModule // , BrowserAnimationsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDateRangePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EIPDateRangePickerComponent],
                    imports: [CommonModule, IntlModule,
                        DateInputsModule, LabelModule, MatFormFieldModule, InputsModule,
                        MatSelectModule, MatOptionModule, FormsModule, PopupModule // , BrowserAnimationsModule
                    ],
                    exports: [EIPDateRangePickerComponent],
                    providers: [DateRangeService]
                }]
        }] });

/*
 * Public API Surface of eipdate-range-picker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EIPDateRangePickerComponent, EIPDateRangePickerModule, EIPDateRangePickerService };
